import { render, staticRenderFns } from "./UmfrageVorlageModal.vue?vue&type=template&id=13860442"
import script from "./UmfrageVorlageModal.vue?vue&type=script&lang=js"
export * from "./UmfrageVorlageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports